export default __webpack_public_path__ + "35659051b355b454fe00fd10aa004702.png";